import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { DefaultFiltersState } from '@/stores'
import { SetFilterValue } from '@/stores/shared.ts'

export interface B2cRegistryTableState extends DefaultFiltersState {}

const initialState: B2cRegistryTableState = {
  page: 0,
  showCount: 10,
}

const b2cRegistryPaymentsSlice = createSlice({
  name: 'b2cRegistryPayments',
  initialState,
  selectors: {
    filters: (state) => ({ page: state.page, showCount: state.showCount, sort: state.sort }),
  },
  reducers: {
    setFilter: (state, action: PayloadAction<SetFilterValue<B2cRegistryTableState>>) => {
      return {
        ...state,
        page: action.payload.filterKey !== 'page' ? 0 : state.page,
        [action.payload.filterKey]: action.payload.filterValue,
      }
    },
    resetFilters: (state, action: PayloadAction<(keyof B2cRegistryTableState)[]>) => {
      const patch = Object.fromEntries(action.payload.map((key) => [key, initialState[key]]))
      return { ...state, ...patch }
    },
  },
})

export const {
  reducer: b2cRegistryPaymentsReducer,
  selectors: b2cRegistryPaymentsSelectors,
  actions: b2cRegistryPaymentsActions,
} = b2cRegistryPaymentsSlice
